import React, {PropsWithChildren} from "react";
import {FormattedMessage} from "react-intl";
import {Alert} from "react-bootstrap";

interface ErrorMessageProps {
    error: { id: string; defaultMessage: string; serviceErrorDetail?: string } | null;
}

const messages = {
    heading: {
        id: "ariSnapshot.error.heading",
        defaultMessage: "oopsy, something went wrong"
    }
}

export function ErrorMessage(props: PropsWithChildren<ErrorMessageProps>): JSX.Element {
    return (
        <>
            {props.error && (
                <Alert variant="danger">
                    <Alert.Heading><FormattedMessage {...messages.heading} /></Alert.Heading>
                    {!props.error.serviceErrorDetail
                        ? <FormattedMessage {...props.error} />
                        : <span><b>Detail:</b> {props.error.serviceErrorDetail}</span>
                    }
                </Alert>
            )}
        </>
    );
}